import {observer} from 'mobx-react';
import Subnav from 'main/containers/benefits/components/Subnav';
import {endpoints} from 'main/tools';
import {Plans} from 'main/components/benefits';

const CompanyPlansContainer = observer(({scope, match, history}) => {
  return (
    <div>
      <Subnav scope={scope}/>
      <Plans 
        match={match}
        history={history}
        listEndpoint={endpoints.COMPANY_INSURANCE_CARRIERS.WITH_OPTIONAL}
        viewEndpoint={endpoints.BENEFITS.BENEFIT_CLASS}
      />
    </div>
  );
});

export default CompanyPlansContainer;
